import { Draggable } from "@hello-pangea/dnd";
import React from "react";
import ReleaseLabel from "./ReleaseLabel";
import { Label } from "./types";

interface DraggableReleaseLabelProps {
  label: Label;
  index: number;
  isActiveVersion: boolean;
  onDelete?: (label: Label) => void;
}

const DraggableReleaseLabel: React.FC<DraggableReleaseLabelProps> = ({
  label,
  index,
  isActiveVersion,
  onDelete,
}) => {
  return (
    <Draggable draggableId={`label-${label.id}-${label.name}`} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`${snapshot.isDragging ? "z-50" : ""}`}
        >
          <ReleaseLabel
            label={label}
            isActiveVersion={isActiveVersion}
            onDelete={onDelete}
            isDragging={snapshot.isDragging}
          />
        </div>
      )}
    </Draggable>
  );
};

export default DraggableReleaseLabel;
